// GENERATED by scripts/generate-art.js - do not edit by hand.
import service_web_development from './service-web-development.svg';
import service_mobile_app_development from './service-mobile-app-development.svg';
import service_ui_ux_design from './service-ui-ux-design.svg';
import service_digital_marketing from './service-digital-marketing.svg';
import service_cloud_solutions from './service-cloud-solutions.svg';
import service_software_development from './service-software-development.svg';
import service_consulting from './service-consulting.svg';
import service_cybersecurity from './service-cybersecurity.svg';
import industry_startups_and_founders from './industry-startups-and-founders.svg';
import industry_energy_and_resources from './industry-energy-and-resources.svg';
import industry_professional_services from './industry-professional-services.svg';
import industry_logistics_and_transportation from './industry-logistics-and-transportation.svg';
import industry_healthcare_and_wellness from './industry-healthcare-and-wellness.svg';
import industry_construction_and_trades from './industry-construction-and-trades.svg';
import industry_retail_and_ecommerce from './industry-retail-and-ecommerce.svg';
import article_what_belongs_in_an_mvp from './article-what-belongs-in-an-mvp.svg';
import article_what_a_website_costs_in_calgary from './article-what-a-website-costs-in-calgary.svg';
import article_build_vs_buy from './article-build-vs-buy.svg';
import article_core_web_vitals_for_business_owners from './article-core-web-vitals-for-business-owners.svg';
import article_seo_basics_for_calgary_businesses from './article-seo-basics-for-calgary-businesses.svg';
import article_why_your_internal_tool_became_a_spreadsheet from './article-why-your-internal-tool-became-a-spreadsheet.svg';
import process_01 from './process-01.svg';
import process_02 from './process-02.svg';
import process_03 from './process-03.svg';
import process_04 from './process-04.svg';
import page_404 from './page-404.svg';
import page_contact from './page-contact.svg';

const art = {
  'service-web-development': service_web_development,
  'service-mobile-app-development': service_mobile_app_development,
  'service-ui-ux-design': service_ui_ux_design,
  'service-digital-marketing': service_digital_marketing,
  'service-cloud-solutions': service_cloud_solutions,
  'service-software-development': service_software_development,
  'service-consulting': service_consulting,
  'service-cybersecurity': service_cybersecurity,
  'industry-startups-and-founders': industry_startups_and_founders,
  'industry-energy-and-resources': industry_energy_and_resources,
  'industry-professional-services': industry_professional_services,
  'industry-logistics-and-transportation': industry_logistics_and_transportation,
  'industry-healthcare-and-wellness': industry_healthcare_and_wellness,
  'industry-construction-and-trades': industry_construction_and_trades,
  'industry-retail-and-ecommerce': industry_retail_and_ecommerce,
  'article-what-belongs-in-an-mvp': article_what_belongs_in_an_mvp,
  'article-what-a-website-costs-in-calgary': article_what_a_website_costs_in_calgary,
  'article-build-vs-buy': article_build_vs_buy,
  'article-core-web-vitals-for-business-owners': article_core_web_vitals_for_business_owners,
  'article-seo-basics-for-calgary-businesses': article_seo_basics_for_calgary_businesses,
  'article-why-your-internal-tool-became-a-spreadsheet': article_why_your_internal_tool_became_a_spreadsheet,
  'process-01': process_01,
  'process-02': process_02,
  'process-03': process_03,
  'process-04': process_04,
  'page-404': page_404,
  'page-contact': page_contact,
};

export default art;
